import SiteSearch from './SiteSearch';

export default SiteSearch;
